var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container text-center"},[_c('h1',[_vm._v("Contact")]),_c('p',{staticClass:"lead"},[_vm._v("Email us at\n        "),_c('a',{attrs:{"href":_vm.email_url}},[_vm._v(_vm._s(_vm.email))])])])}
var staticRenderFns = []

export { render, staticRenderFns }